<template>
  <section>
    <div id="gjs-nl" class="gjs-editor-cont"></div>
  </section>
</template>

<script>
import grapesjs from 'grapesjs'
import grapesJSMJML from 'grapesjs-mjml'

import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'

import { storageManagerConfig } from '../configGrapes/storage-manager.config'

import loadPanels from '../configGrapes/panels-config'
import loadCommands from '../configGrapes/commands-config'

export default {
  name: 'Grapes2',
  data() {
    return {
      messages: [],
      loading: false,
      loagingPage: true,
      editor: null,
      commands: null,
      templateName: null,
      nameTimeout: null,
      autoLoad: false,
      urlStore: null,
      urlLoad: null,
      customTypes: [],
      personalizationTags: null,
      autoSaving: null
    }
  },
  mixins: [validationMixin],

  validations: {
    templateName: {
      required,
      minLength: minLength(3)
    }
  },

  mounted() {
    this.editor = grapesjs.init({
      fromElement: 1,
      container: '#gjs-nl',
      cors: {
        enabled: true,
        origin: this.$configs.VUE_APP_ROOT_API
      },
      storageManager: storageManagerConfig(this.autoLoad, this.urlStore, this.urlLoad),
      plugins: [grapesJSMJML],
      pluginsOpts: {
        [grapesJSMJML]: {}
      },
      AssetManager: {}
    })

    loadPanels(this.editor, this)
    loadCommands(this.editor, this)

    // html MJML dentro do grapes - iniciar com ele ja no HTML gera erro no console
    this.editor.setComponents(`<mjml><mj-body></mj-body></mjml>`)

    // usei o event de 'component:mount do grapes porem deixou de funcinar o chrome
    setTimeout(() => {
      this.editButtons()
      this.removeButtons()
    }, 300)
    this.editor.on('component:mount', this.editButtons)
    this.editor.on('component:mount', this.removeButtons)
  },

  methods: {
    editButtons() {
      this.editor.Panels.getButton('views', 'open-blocks').set('active', true)
      this.editor.Panels.getButton('options', 'redo').set('className', 'fa fa-redo')
    },

    removeButtons() {
      const exportTemplate = this.editor.Panels.getButton('options', 'export-template')
      const mjmlImport = this.editor.Panels.getButton('options', 'mjml-import')
      const layer = this.editor.Panels.getButton('views', 'open-layers')
      exportTemplate.collection.remove(exportTemplate)
      mjmlImport.collection.remove(mjmlImport)
      layer.collection.remove(layer)
    }
  }
}
</script>

<style lang="scss">
.page-messages {
  position: absolute;
  bottom: 0;
  z-index: 10;
}

.page {
  .templateName {
    max-width: 700px;
    position: absolute;
    z-index: 10;
    left: 1%;
    top: 10px;

    .form-group {
      display: flex;
      flex-direction: column;

      label {
        display: none;
      }
    }

    input.form-control {
      height: 40px;
      background: transparent;
      border-bottom: 1px solid white;
      color: white;
    }
  }

  &.disabled {
    .templateName {
      position: fixed;
      top: 15%;
      transform: translateX(-85%);
      left: 50%;

      .form-group {
        display: flex;
        flex-direction: column;

        label {
          display: block;
          font-size: 30px;
          text-align: center;
          width: 100%;
          color: $gray-base;
        }

        .form-control {
          height: 50px;
          border-bottom: 1px solid $gray-base;
          color: $gray-base;

          &:active,
          &:hover,
          &:focus {
            box-shadow: none !important;
          }
        }
      }
    }
  }
}

.saving {
  position: absolute;
  top: 10%;
  left: 5%;
  z-index: 10;
}
</style>
